import { Text, View } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";

// The single gap between every line of this block. One constant rather than a
// margin per row: the rows previously carried three different values and the
// spacing read as uneven on the printed sheet.
const ROW_GAP = 5;

export default function WOPdfInfo({
  styles,
  selectedWO,
  productsList,
  showContactShipping,
}) {
  /*   All States
   ********************************************* */
  const [productDetails, setProductDetails] = useState("");
  const [totalQty, setTotalQty] = useState(0);

  const customerInfo =
    typeof selectedWO?.contactData === "string"
      ? JSON.parse(selectedWO?.contactData)
      : selectedWO?.contactData;

  const shippingAddress =
    typeof selectedWO?.shippingAddress === "string"
      ? JSON.parse(selectedWO?.shippingAddress)
      : selectedWO?.shippingAddress;

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    if (productsList) {
      let detail = productsList.reduce((acc, item) => {
        if (acc[item.productStyle]) {
          acc[item.productStyle] += parseInt(item.totalQuantity);
        } else {
          acc[item.productStyle] = item?.totalQuantity;
        }
        return acc;
      }, {});

      let formattedProductDetail = "";
      for (const [productStyle, totalQuantity] of Object.entries(detail)) {
        formattedProductDetail += `${productStyle} = ${totalQuantity}, `;
      }

      setProductDetails(formattedProductDetail);

      setTotalQty(
        productsList.reduce((acc, item) => {
          let qty = parseInt(item.totalQuantity) || 0;
          return acc + qty;
        }, 0),
      );
    }
  }, [productsList]);
  return (
    <>
      {/* Even spacing across the four lines.
          Before: the gaps ran 10 / 0 / 5 -- Shipping carried a 5pt bottom
          margin AND the next block a 5pt top margin, while Job Name and
          Customer Name sat inside one block with nothing between them at all.
          Now every line after the first carries ROW_GAP and nothing else, so
          the gaps are equal. The total is unchanged (15pt over three gaps
          either way), which is why the first and last lines have not moved. */}
      <View
        style={{
          ...styles.shippingDescription,
          marginBottom: 0,
        }}
      >
        {showContactShipping && (
          <View style={{ ...styles.shippingDescription, marginTop: 5 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text
                style={{
                  ...styles.headingSecond,
                  textAlign: "left",
                }}
              >
                Shipping Address: &nbsp;
                {selectedWO?.shippingMethod?.name === "Customer Pickup" ? (
                  <Text style={{}}>{selectedWO?.shippingMethod?.name}</Text>
                ) : (
                  shippingAddress && (
                    <Text style={{}}>
                      {shippingAddress?.addressCompany &&
                      selectedWO?.customerName?.toLowerCase() ===
                        shippingAddress?.addressCompany?.toLowerCase()
                        ? ""
                        : shippingAddress?.addressCompany + ", "}
                      {shippingAddress?.addressLine1 &&
                        shippingAddress?.addressLine1 + ", "}
                      {shippingAddress?.addressLine2 &&
                        shippingAddress?.addressLine2 + ", "}
                      {shippingAddress?.city && shippingAddress?.city + ", "}
                      {shippingAddress?.state && shippingAddress?.state + ", "}
                      {shippingAddress?.zip && shippingAddress?.zip + ", "}
                      {shippingAddress?.country &&
                        shippingAddress?.country + ", "}
                    </Text>
                  )
                )}
              </Text>
            </View>
          </View>
        )}
      </View>

      {/* Job Name Shipping info */}

      {/* Job Name and Customer Name are their own rows now. They used to share
          one block, which is why they alone had no gap between them. */}
      <View
        style={{
          ...styles.shippingDescription,
          marginTop: ROW_GAP,
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Text
          style={{
            ...styles.headingSecond,
            textAlign: "left",
          }}
        >
          Job Name: <Text style={{}}>{selectedWO?.jobName}</Text>
        </Text>
      </View>

      <View
        style={{
          ...styles.shippingDescription,
          marginTop: ROW_GAP,
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Text
          style={{
            ...styles.headingSecond,
            textAlign: "left",
          }}
        >
          Customer Name: <Text style={{}}>{selectedWO?.customerName}</Text>
        </Text>
      </View>

      <View style={{ ...styles.shippingDescription, marginTop: ROW_GAP }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Text
            style={{
              ...styles.headingSecond,
              textAlign: "left",
            }}
          >
            Product summary: ( {productsList?.length} - {totalQty} ){" "}
            {productDetails}
          </Text>
        </View>
      </View>
    </>
  );
}
